<script setup lang="ts">

const colorMode = useColorMode();
const route = useRoute();
</script>

<template>

  <div class="flex flex-col">

    <div class="relative top-px flex w-full justify-start overflow-x-auto gap-x-4 pt-2 px-6">

      <UButton
        v-for="link in [...topMenuLinks, ...bottomMenuLinks].filter(l => !l.disabled)"
        :disabled="link.disabled"
        :to="link.to"
        color="white"
        variant="ghost"
        :class="[
          route.name === link.key ? 'text-black border-x border-t rounded-b-none bg-white dark:bg-gray-900 dark:border-gray-700' : 'text-gray-500',
        ]"
        class="flex flex-col active:!bg-transparent space-y-1 items-center justify-center flex-1 min-w-[70px] py-3">

        <UIcon
          class="text-xl"
          :name="link.icon" />
        <span
          :class="[
            route.name === link.key ? 'font-semibold' : '',
          ]"
          class="text-2xs">{{ link.label }}</span>

      </UButton>

    </div>

    <div class="border-t dark:border-gray-700 bg-white dark:bg-gray-900 h-2">

    </div>

  </div>

</template>
